import React, { useState } from "react";
import Lottie from "react-lottie";
import "./Help_lottie_holder.css";
import * as animationData from "./Help_lottie_holder.json";
import HelpModal from "../Common-Component/Common_Modal/HelpModal/HelpModal";

function Help_lottie_holder() {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <div
        className="Help_lottie_holder"
        onClick={() => {
          setShowHelpModal(true);
        }}
      >
        <Lottie options={defaultOptions} />
      </div>

      <HelpModal
        show={showHelpModal}
        onHide={() => {
          setShowHelpModal(false);
        }}
      />
    </>
  );
}
export default Help_lottie_holder;
